import { useState } from 'react';
import { CreateWorkflowNode, SubworkflowCommonConfiguration } from 'api/model';
import FormBlock from 'components/form/FormBlock';
import useWorkflows from 'api/workflows/useWorkflows';
import { NodeFormProps } from 'api/workflows-steps/formSchema';
import { useNodeValidation } from 'hooks/useNodeValidation';

type SubworkflowCommonFormProps = NodeFormProps & {
  validate?: boolean;
};

const SubworkflowCommonForm = (props: SubworkflowCommonFormProps) => {
  const { validate = true } = props;
  const { workflows } = useWorkflows({ summary: true });
  const [formData, setFormData] = useState<CreateWorkflowNode>(props.initialValues || ({} as CreateWorkflowNode));

  const { validate: validateNode } = useNodeValidation(formData.type);

  const handleOnChange = (newFormData: CreateWorkflowNode) => {
    const newConfiguration = newFormData.configuration as SubworkflowCommonConfiguration | undefined;
    if (!newConfiguration) {
      setFormData(newFormData);
      props.onChange?.(newFormData);
      return;
    }

    const configuration = formData.configuration as SubworkflowCommonConfiguration;

    const workflowId = newConfiguration?.workflow_id;
    if (!workflowId) {
      newConfiguration.revision = undefined;
    } else if (workflowId !== configuration?.workflow_id) {
      const workflow = workflows?.find((p) => p.id === workflowId);
      if (workflow) {
        newConfiguration.revision = workflow.revision;
      }
    }

    const updatedFormData = { ...newFormData, configuration: newConfiguration };
    setFormData(updatedFormData);
    props.onChange?.(updatedFormData);
  };

  const handleSubmit = async (newFormData: CreateWorkflowNode) => {
    if (validate && !(await validateNode(newFormData))) {
      return;
    }

    setFormData(newFormData);
    props.onSubmit?.(newFormData);
  };

  return <FormBlock {...props} onSubmit={handleSubmit} onChange={handleOnChange} />;
};

export default SubworkflowCommonForm;
